export default __webpack_public_path__ + "static/media/arrow.02ce2cfd.webp";